const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSettingPlusGreenIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__add_request",
    "data-name": "add request",
    transform: "translate(-1348 -188)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_62",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    "data-name": "Ellipse 62",
    transform: "translate(1348 188)",
    style: {
      fill: "#dbf4e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_471",
    d: "M30.883 977.362a1.177 1.177 0 0 0-1.177 1.177v3.53h-3.53a1.177 1.177 0 0 0 0 2.353h3.53v3.53a1.177 1.177 0 1 0 2.353 0v-3.53h3.53a1.177 1.177 0 0 0 0-2.353H32.06v-3.53a1.177 1.177 0 0 0-1.177-1.177z",
    "data-name": "Path 471",
    transform: "translate(1333.725 -778.637)",
    style: {
      fill: "#00d95c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSettingPlusGreenIcon);
export default __webpack_public_path__ + "static/media/data-setting-plus-green-icon.12cfa8714bc93f74cc966a24fc6da795.svg";
export { ForwardRef as ReactComponent };